"use strict";

const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");

class NavToggle extends HTMLElement {
    constructor() {
        super();

        this.root = this.attachShadow({ mode: "open" });

        const content = baseTemplate.content.cloneNode(true);
        this.root.appendChild(content);
        this.input = this.root.querySelector("input");

        // this.root.addEventListener("change", function (event) {
        //     console.log(event.target)
        //
        //     this.dispatchEvent(new CustomEvent("toggle", {
        //         detail: {
        //             open: this.checked
        //         }
        //     }));
        //
        // }.bind(this));
        // this.a = this.root.querySelector("a");
        // this.href = this.getAttribute("href");
        // if (this.href) {
        //     this.button = document.createElement("a");
        //     this.button.setAttribute("href", this.href);
        //     this.button.setAttribute("rel", "noopener");
        //     this.button.setAttribute("target", "_blank");
        // } else {
        //     this.button = document.createElement("button");
        // }
        //
        // // arrow
        // this.iconName = this.gettAttribute("icon");
        // // this.button = this.root.appendChild(this.button);
        // //
        // if (this.innerHTML) {
        //     this.a.innerHTML = this.innerHTML;
        //     if (this.iconName) {
        //         const icon = document.createElement("div");
        //         icon.className = this.iconName;
        //         this.a.appendChild(icon);
        //     }
        //
        // }
        // if (this.hasAttribute("href")) {
        //     this.a.setAttribute("href", this.getAttribute("href"));
        //     this.removeAttribute("href");
        // }
        // this.innerHTML = "";

    }

    // connectedCallback() {
        // arrow
        // this.iconName = this.getAttribute("icon");
        // // this.button = this.root.appendChild(this.button);
        // //
        // if (this.innerHTML) {
        //     this.a.innerHTML = this.innerHTML;
        //     if (this.iconName) {
        //         const icon = document.createElement("div");
        //         icon.className = this.iconName;
        //         this.a.appendChild(icon);
        //     }
        //
        // }
        // if (this.hasAttribute("href")) {
        //     this.a.setAttribute("href", this.getAttribute("href"));
        //     this.removeAttribute("href");
        // }
        // this.innerHTML = "";
    // }




}

window.customElements.define("swiftref-nav-toggle", NavToggle);

module.exports = NavToggle;
